module.exports = __webpack_public_path__ + "img/thermostat-sans-fil.d5c2f2d5.jpg";